@if (detection && (currentUser$ | async); as user) {
  <div class="container">
    <!------- Header ------->
    <div class="header"
      [ngClass]="(isExpanded$ | async) ? 'header-expanded' : 'header-collapsed'">
      <div class="header-left">
        @if (detection.status != detectionStatusEnum.TO_BE_CONFIRMED) {
          <div [style.background-color]="detection.textColor"
          class="detection-color-box"></div>
        }
        <div class="info">
          <div class="title">{{detection.name}}</div>
          <div class="sub-title">{{detection.createMode | formatDetectionMode}}</div>
          <div class="sub-title">{{detection.center | wgs84}}</div>
        </div>
      </div>
      <div class="header-actions">
        @if (!(isExpanded$ | async)) {
          <button mat-icon-button
            matTooltip="{{'expand' | transloco}}"
            (click)="onClickExpand()">expand_content
          </button>
        }
        @if ((isExpanded$ | async)) {
          <button mat-icon-button
            matTooltip="{{'collapse' | transloco}}"
            (click)="onClickCollapse()">collapse_content
          </button>
        }
        <button mat-icon-button
          matTooltip="{{'close' | transloco}}"
          (click)="onClickClose()">close
        </button>
      </div>
    </div>
    <!------- Content ------->
    <div class="content"
      [ngClass]="(isExpanded$ | async) ? 'content-expanded' : 'content-collapsed'">
      <div class="main"
        [ngClass]="(isExpanded$ | async) ? 'main-expanded' : 'main-collapsed'">
        <div [ngClass]="{'row': (isExpanded$ | async), 'col': !(isExpanded$ | async)}">
          <div class="section-title">{{'confidence_index' | transloco | uppercase}} :</div>
          <div class="indicators">{{detection | confidence | number:'1.0-0'}} %</div>
        </div>
        <!--      <div [ngClass]="{'row': (isExpanded$ | async), 'col': !(isExpanded$ | async)}">-->
        <!--        <div class="section-title">{{'evolution_indicator' | transloco | uppercase}} :</div>-->
        <!--        <div class="indicators">{{detection | evolution | number:'1.0-0'}} %</div>-->
      <!--      </div>-->
      <form [formGroup]="form">
        @if (siteDetectionLabels) {
          <mat-form-field class="row">
            <mat-label>{{'type' | transloco}}</mat-label>
            <mat-select required formControlName="type">
              @for (item of siteDetectionLabels; track item) {
                <mat-option [value]="item.label">{{item.name}}</mat-option>
              }
            </mat-select>
          </mat-form-field>
        }
        <mat-form-field class="row">
          <mat-label>{{'status' | transloco}}</mat-label>
          <mat-select required formControlName="status">
            <mat-option [value]="detectionStatusEnum.TO_BE_CONFIRMED">{{'to_confirm' | transloco}}</mat-option>
            <mat-option [value]="detectionStatusEnum.CONFIRMED">{{'confirmed' | transloco}}</mat-option>
          </mat-select>
        </mat-form-field>
        @if (statusFormControl.value == detectionStatusEnum.CONFIRMED && emergencyTemplate) {
          <mat-form-field
            class="row">
            <mat-label>{{'emergency_level' | transloco}}</mat-label>
            <mat-select formControlName="emergency">
              @for (item of emergencyTemplate.labels; track item) {
                <mat-option value="{{item.priority}}">
                  <span style="position: relative;">
                    {{item.label}}
                    <div class="emergency-badge" [style.background-color]="item.color"></div>
                  </span>
                </mat-option>
              }
            </mat-select>
          </mat-form-field>
        }
        @if (formHasChanged) {
          <button
            class="btn-save"
            mat-button
            (click)="onClickUpdate(detection)">
            {{'save_changes' | transloco}}
          </button>
        }
      </form>
      <!------- Split buttons ------->
      @if ((isExpanded$ | async) && referenceBatch && referenceAttachments.length) {
        <div class="buttons">
          <mat-button-toggle-group
            [hideSingleSelectionIndicator]="true"
            [value]="selectedSplitScreenMode"
            (change)="onSplitModeChanged($event.value)">
            <mat-button-toggle [checked]="selectedSplitScreenMode == 0" value="0">
              <mat-icon>splitscreen_left</mat-icon>
            </mat-button-toggle>
            <mat-button-toggle [checked]="selectedSplitScreenMode == 1" value="1">
              <mat-icon>split_scene</mat-icon>
            </mat-button-toggle>
            <mat-button-toggle [checked]="selectedSplitScreenMode == 2" value="2">
              <mat-icon>splitscreen_right</mat-icon>
            </mat-button-toggle>
          </mat-button-toggle-group>
        </div>
      }
      <!------- Pictures ------->
      @if ((isExpanded$ | async)) {
        <div class="pictures">
          <!------- Reference batch ------->
          @if (referenceBatch) {
            <div
              class="left"
          [ngClass]="{
            'left-expanded': (isExpanded$ | async),
            'left-side-open': (isExpanded$ | async) && selectedSplitScreenMode == 0,
            'left-side-close': (isExpanded$ | async) && selectedSplitScreenMode == 2
          }">
              @if (selectedSplitScreenMode != 2) {
                <mat-label
                  class="mat-label-overlay">
                  {{ referenceBatch.dateAcquired | date:dateFormat(user) }}
                </mat-label>
              }
              @if (referenceAttachments.length) {
                <div
                  class="attachments-carousel-host">
                  @if ((currentOrganizationId$ | async); as organizationId) {
                    <attachments-carousel
                      [attachments]="referenceAttachments"
                      [organizationId]="organizationId"
                      [enablePanzoom]="true"
                      [showOverlay]="true"
                      [allowDownload]="true"
                      [navigationMode]="'thumbnails'">
                    </attachments-carousel>
                  }
                </div>
              }
              @if (!referenceAttachments.length) {
                <div
                  class="empty-picture">
                  <mat-icon>broken_image</mat-icon>
                </div>
              }
            </div>
          }
          <!------- Last batch ------->
          <div
            class="right"
          [ngClass]="{
            'right-expanded': (isExpanded$ | async),
            'right-side-open': (isExpanded$ | async) && selectedSplitScreenMode == 2,
            'right-side-close': (isExpanded$ | async) && selectedSplitScreenMode == 0,
            'full-size': (isExpanded$ | async) && !referenceBatch
          }">
            @if (selectedSplitScreenMode != 0 && site && referenceBatch) {
              <mat-label
                class="mat-label-overlay">
                {{ site.lastBatchDate | date:dateFormat(user) }}
              </mat-label>
            }
            @if (attachments.length) {
              <div
                class="attachments-carousel-host">
                @if ((currentOrganizationId$ | async); as organizationId) {
                  <attachments-carousel
                    [attachments]="attachments"
                    [organizationId]="organizationId"
                    [enablePanzoom]="true"
                    [showOverlay]="true"
                    [allowDownload]="true"
                    [allowFavorite]="true"
                    [favoriteFilename]="detection.favorite"
                    [navigationMode]="'thumbnails'"
                    (favoriteChange)="onFavoriteChange($event)">
                  </attachments-carousel>
                }
              </div>
            }
            @if (!attachments.length) {
              <div
                class="empty-picture">
                <mat-icon>broken_image</mat-icon>
              </div>
            }
          </div>
        </div>
      }
      <!------- Actions ------->
      <div class="actions">
        @if (!(isExpanded$ | async)) {
          <button
            mat-icon-button
            matTooltip="{{'move_the_camera_on_the_detection' | transloco}}"
            class="material-symbols-outlined"
            (click)="onClickFlyTo(detection)">my_location
          </button>
        }
        @if (!(isExpanded$ | async)) {
          <button
            mat-icon-button
            [matTooltip]="(detection.show ? 'hide_overlay' : 'show_overlay') | transloco"
            [disabled]="!(displayDetections$ | async)"
            (click)="onClickToggleShow(detection)">
            <mat-icon>
              {{ detection.show ? 'visibility' : 'visibility_off' }}
            </mat-icon>
          </button>
        }
        <span class="spacer"></span>
        <button style="color: var(--warn-color)"
          mat-icon-button
          matTooltip="{{'delete' | transloco}}"
          (click)="onClickDelete(detection)">delete
        </button>
      </div>
    </div>
    <div class="side"
      [ngClass]="(isExpanded$ | async) ? 'side-expanded' : 'side-collapsed'">
      <!------- History ------->
      <detection-history-channel class="history"
        [itemId]="detection.id"
      [itemPool]="detection.pool"></detection-history-channel>
    </div>
  </div>
</div>
}
